/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TriggerType/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import AppointmentBookingsStateUpdate from './AppointmentBookingsStateUpdate/index'
import ContractSigned from './ContractSigned/index'
import CustomResourceInsert from './CustomResourceInsert/index'
import DocumentSigned from './DocumentSigned/index'
import MedicalFormSubmitted from './MedicalFormSubmitted/index'
import No from './No/index'
import OrderStatusChanged from './OrderStatusChanged/index'
import PatientDemographicsChanged from './PatientDemographicsChanged/index'
import PaymentMade from './PaymentMade/index'
import PaymentMethodUpdated from './PaymentMethodUpdated/index'
import React from 'react'
import TxsStatusUpdate from './TxsStatusUpdate/index'



/** @type {import('Simple/types.js').View} */
export default function TriggerType({
  children,
  viewPath = "/DesignSystem/EditAutomation/TriggerType"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let automationEventTypeValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'event_type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: automationEventTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'AppointmentBookingsStateUpdate'}>
<AppointmentBookingsStateUpdate
  viewPath={`${viewPath}/AppointmentBookingsStateUpdate`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TxsStatusUpdate'}>
<TxsStatusUpdate
  viewPath={`${viewPath}/TxsStatusUpdate`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CustomResourceInsert'}>
<CustomResourceInsert
  viewPath={`${viewPath}/CustomResourceInsert`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PatientDemographicsChanged'}>
<PatientDemographicsChanged
  viewPath={`${viewPath}/PatientDemographicsChanged`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ContractSigned'}>
<ContractSigned
  viewPath={`${viewPath}/ContractSigned`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'OrderStatusChanged'}>
<OrderStatusChanged
  viewPath={`${viewPath}/OrderStatusChanged`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DocumentSigned'}>
<DocumentSigned
  viewPath={`${viewPath}/DocumentSigned`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'MedicalFormSubmitted'}>
<MedicalFormSubmitted
  viewPath={`${viewPath}/MedicalFormSubmitted`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PaymentMade'}>
<PaymentMade
  viewPath={`${viewPath}/PaymentMade`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PaymentMethodUpdated'}>
<PaymentMethodUpdated
  viewPath={`${viewPath}/PaymentMethodUpdated`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}